module.exports = __webpack_public_path__ + "img/add-option.895bcfe8.svg";